import React, { useState, useEffect } from 'react';
import { settingsService } from '../../services/settingsService';
import { useAuthStore } from '../../stores/authStore.js';

function Profile() {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const { user } = useAuthStore();
  const [profile, setProfile] = useState({
    namaKoperasi: '',
    namaSingkat: '',
    badanHukumNo: '',
    tglBerdiri: '',
    alamat: '',
    kota: '',
    kodePos: '',
    telp: '',
    fax: '',
    email: '',
    website: '',
    logoUrl: ''
  });

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      setLoading(true);
      console.log('Profile: Fetching profile...');
      const res = await settingsService.getProfile();
      console.log('Profile: API response:', res);
      console.log('Profile: res.data:', res.data);
      console.log('Profile: res.data.data:', res.data?.data);

      if (res.data?.data) {
        const p = res.data.data;
        console.log('Profile: Raw data from API:', p);
        console.log('Profile: NamaKoperasi:', p.NamaKoperasi);
        setProfile({
          namaKoperasi: p.NamaKoperasi || '',
          namaSingkat: p.NamaSingkat || '',
          badanHukumNo: p.BadanHukumNo || '',
          tglBerdiri: p.TglBerdiri ? p.TglBerdiri.split('T')[0] : '',
          alamat: p.Alamat || '',
          kota: p.Kota || '',
          kodePos: p.KodePos || '',
          telp: p.Telp || '',
          fax: p.Fax || '',
          email: p.Email || '',
          website: p.Website || '',
          logoUrl: p.LogoUrl || ''
        });
        console.log('Profile: State updated');
      } else {
        console.log('Profile: No data in response');
      }
    } catch (error) {
      console.error('Profile: Error fetching profile:', error);
      console.error('Profile: Error response:', error.response?.data);
    } finally {
      setLoading(false);
    }
  };

  const saveProfile = async () => {
    setSaving(true);
    try {
      const kodeCabang = user?.kodeCabang || user?.cabangId || '01';
      await settingsService.updateProfile({ ...profile, kodeCabang });
      alert('Profil cooperativa berhasil disimpan');
    } catch (error) {
      alert(error.response?.data?.message || 'Gagal menyimpan profil');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title"><i className="fas fa-building mr-2"></i>Profil Cooperativa</h3>
      </div>
      <div className="card-body">
        {loading ? (
          <div className="text-center py-3"><i className="fas fa-spinner fa-spin mr-2"></i>Memuat...</div>
        ) : (
          <>
            <div className="row">
              <div className="col-md-6">
                <div className="form-group">
                  <label>Nama Cooperativa *</label>
                  <input type="text" className="form-control" value={profile.namaKoperasi} onChange={e => setProfile({...profile, namaKoperasi: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Nama Singkat</label>
                  <input type="text" className="form-control" value={profile.namaSingkat} onChange={e => setProfile({...profile, namaSingkat: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>No. Badan Hukum</label>
                  <input type="text" className="form-control" value={profile.badanHukumNo} onChange={e => setProfile({...profile, badanHukumNo: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Tanggal Berdiri</label>
                  <input type="date" className="form-control" value={profile.tglBerdiri} onChange={e => setProfile({...profile, tglBerdiri: e.target.value})} />
                </div>
              </div>
              <div className="col-md-6">
                <div className="form-group">
                  <label>Alamat</label>
                  <textarea className="form-control" rows="2" value={profile.alamat} onChange={e => setProfile({...profile, alamat: e.target.value})}></textarea>
                </div>
                <div className="form-group">
                  <label>Kota</label>
                  <input type="text" className="form-control" value={profile.kota} onChange={e => setProfile({...profile, kota: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Kode Pos</label>
                  <input type="text" className="form-control" value={profile.kodePos} onChange={e => setProfile({...profile, kodePos: e.target.value})} />
                </div>
                <div className="form-group">
                  <label>Telepon</label>
                  <input type="text" className="form-control" value={profile.telp} onChange={e => setProfile({...profile, telp: e.target.value})} />
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label>Fax</label>
                  <input type="text" className="form-control" value={profile.fax} onChange={e => setProfile({...profile, fax: e.target.value})} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Email</label>
                  <input type="email" className="form-control" value={profile.email} onChange={e => setProfile({...profile, email: e.target.value})} />
                </div>
              </div>
              <div className="col-md-4">
                <div className="form-group">
                  <label>Website</label>
                  <input type="text" className="form-control" value={profile.website} onChange={e => setProfile({...profile, website: e.target.value})} />
                </div>
              </div>
            </div>
            <button className="btn btn-primary" onClick={saveProfile} disabled={saving}>
              {saving ? <i className="fas fa-spinner fa-spin mr-2"></i> : <i className="fas fa-save mr-2"></i>}
              Simpan Profil
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default Profile;